export const VISUAL_HIERARCHY = {
  primary: {
    // points highlight
    highlighterIconOpacity: 1,
    highlighterIcon: "/mapIcons/activeHighlighter.png",
    highlightIconsZoomSteps: { zoom1: 8, zoom2: 12 }, // currently implemented to update only on 2 zoom levels
    highlighterIconSize: { base: 0.07, zoom8: 0.13, zoom12: 0.17 }, // these are coupled to zoom steps
    highlighterIconOffset: [0, 80],
    // polygon highlight
    fillOpacity: 0.7,
    // line highlight
    lineWidth: 6
  },
  secondary: {
    // points highlight
    highlighterIconOpacity: 1, // has different colored not tweaked on opacity
    highlighterIcon: "/mapIcons/searchHighlighter.png",
    highlightIconsZoomSteps: { zoom1: 8, zoom2: 12 }, // currently implemented to update only on 2 zoom levels
    highlighterIconSize: { base: 0.04, zoom8: 0.09, zoom12: 0.13 }, // these are coupled to zoom steps
    iconOffset: [0, 80],
    // polygon highlight
    fillOpacity: 0.4,
    // line highlight
    lineWidth: 3
  },
  // For tertiary mostly applied the existing values getting from the mapLibreLayers
  tertiary: {
    highlighterIconOpacity: 0,
    depriorotisedIcon: "/mapIcons/depriorotisedFeature.png",
    iconOpacity: 0.8,
    iconsZoomSteps: { zoom1: 8, zoom2: 12 }, // currently implemented to update only on 2 zoom levels
    iconSize: { base: 0.03, zoom8: 0.05, zoom12: 0.07 }, // these are coupled to zoom steps
    // polygon style
    fillOpacity: 0.2,
    fillColor: "#667085",
    // line style
    lineWidth: 1,
    lineColor: "#98A2B3"
  }
} as const;
